import { Box, Paper, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import NotificationInvoiceIcon from '../../assets/notification-invoice.svg';
import NotificationProjectIcon from '../../assets/notification-project-talent.svg';
import NotificationRequestsIcon from '../../assets/notification-requests.svg';
import { INVOICES, PROJECTS } from '../../router/constants';

interface Props {
  name: string;
  iconSrc: string;
  onNotificationClick?: () => void;
  projects?: number;
  requests?: number;
  invoices?: number;
  children?: React.ReactNode;
}

interface NotificationListProps {
  projects?: number;
  requests?: number;
  invoices?: number;
}

const NotificationCard = (props: Props): JSX.Element => {
  return (
    <Paper
      sx={{ flex: '1 1 0px', height: '150px', p: 3, cursor: 'pointer' }}
      onClick={props.onNotificationClick}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography color="primary" variant="h6">
          {props.name}
        </Typography>
        <img src={props.iconSrc} alt="icon" />
      </Box>
      {props.children}
    </Paper>
  );
};

const NotificationsList = (props: NotificationListProps): JSX.Element => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        gap: 3,
        mb: 4
      }}
    >
      <NotificationCard
        name="REQUESTS"
        iconSrc={NotificationRequestsIcon}
        onNotificationClick={() => navigate(PROJECTS)}
      >
        <Typography color="grey.900" fontWeight="bold">
          {props.requests
            ? props.requests > 1
              ? `${props.requests} Project Requests`
              : `${props.requests} Project Request`
            : '0 Project Requests'}
        </Typography>
      </NotificationCard>
      <NotificationCard name="PROJECTS" iconSrc={NotificationProjectIcon}>
        <Typography color="grey.900" fontWeight="bold">
          {props.projects
            ? props.projects > 1
              ? `${props.projects} Projects `
              : `${props.projects} Project `
            : '0 Projects '}
          In Progress
        </Typography>
      </NotificationCard>
      <NotificationCard
        name="INVOICES"
        iconSrc={NotificationInvoiceIcon}
        onNotificationClick={() =>
          navigate(INVOICES, { state: { notification: 3 } })
        }
      >
        <Typography color="grey.900" fontWeight="bold">
          {props.invoices
            ? props.invoices > 1
              ? `${props.invoices} Open Invoices`
              : `${props.invoices} Open Invoice`
            : '0 Open Invoices'}
        </Typography>
      </NotificationCard>
    </Box>
  );
};

export default NotificationsList;
